import React from "react";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import styles from "./styles";

import SearchBar from "../common/search";
import Table from "../table";
import RowLink from "../table/cells/rowlink";
import Title from "../ui/title";
import Content from "../ui/content";
import Context from "./context/";
import Toolbar from "./toolbar/";

import NewCustorg from "../common/custorg/new";
import CustorgLogo from "../common/custorg/logo";

import withRole from "../hoc/role";
import ConfirmDialog from "../common/dialog/confirm";
import TestsRowLink from "../table/cells/testsRowLink";
import {
  ROLES_CLIENT,
  ROLES_CLIENT_ADMIN,
  ROLES_CLIENT_MANAGER
} from "../../common/constants";

const ViewRowLink = withRole(
  props => {
    return <RowLink {...props} />;
  },
  [...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER]
);

const EditButton = withRole(
  props => {
    return (
      <Button raised mini onClick={() => props.action()}>
        {props.title}
      </Button>
    );
  },
  [...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER]
);

const DeleteButton = withRole(
  props => {
    return (
      <Button raised onClick={() => props.action()}>
        {props.title}
      </Button>
    );
  },
  [...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER]
);

const JobsRowLink = withRole(props => {
  return <RowLink {...props} />;
}, ROLES_CLIENT);

class Customers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      logoModal: null,
      mode: null,
      contextMenu: false,
      showConfirmDelete: false,
      currentRow: null,
      selected: {},
      selectAll: false,
      filter: false,
      filterable: false
    };
    this.toggle = this.toggle.bind(this);
    this.toggleColumns = this.toggleColumns.bind(this);
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.showLogoModal = this.showLogoModal.bind(this);
    this.closeLogoModal = this.closeLogoModal.bind(this);
    this.add = this.add.bind(this);
    this.edit = this.edit.bind(this);
    this.del = this.del.bind(this);
    this.showConfirmDel = this.showConfirmDel.bind(this);
    this.hideConfirmDel = this.hideConfirmDel.bind(this);
    this.view = this.view.bind(this);
  }
  view(e, customers) {
    e.preventDefault();
  }
  componentWillMount() {
    const { customers, pager, translate, roles, view } = this.props;
    const { defaultColumns } = pager;
    const { filterable } = this.state;
    let columns = [];
    customers.columns.forEach((column, index) => {
      if (column.field === "name") {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          toggle: false,
          display: column.display,
          Cell: o => {
            return (
              <React.Fragment>
                <Typography>{o.row.name}</Typography>

                {/* <TestsRowLink title={` (${translate("general_jobs")})`} key={o.row.detail} link={`/jobs/${o.row.id}`} /> */}
              </React.Fragment>
            );
          },
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort
        });
      } else {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          toggle: true,
          display: column.display,
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort
        });
      }
    });

    columns.push({
      id: "detail",
      Header: translate("action"),
      accessor: d => d.id,
      Cell: o => {
        return (
          <React.Fragment>
            <JobsRowLink
              view={this.view}
              link={`/jobs/${o.row.id}`}
              title={translate("general_jobs")}
            />
          </React.Fragment>
        );
      },
      filterable: false,
      sortable: false,
      cansearch: false,
      display: false
    });

    this.setState({
      columns: columns
    });
  }

  toggle() {
    this.setState({
      contextMenu: !this.state.contextMenu
    });
  }

  toggleColumns(column) {
    let columns = [...this.state.columns];
    columns.forEach(c => {
      if (c.id === column.id) {
        c.show = column.show;
      }
    });
    this.setState({
      columns: columns
    });
  }

  toggleFilters = () => {
    let columns = [...this.state.columns];
    let { filterable } = this.state;
    columns.forEach(c => {
      c.filterable = c.cansearch && !filterable;
    });
    this.setState({
      columns: columns,
      filterable: !filterable
    });
  };

  add() {
    this.showModal("create");
  }

  edit(row) {
    this.props.get(row);
    this.props.getTargets4(row);
    this.props.getTargets6(row);
    this.props.getCableList(row);
    this.showModal("edit");
  }

  showModal(mode) {
    this.setState({
      modal: true,
      mode
    });
  }

  closeModal(reset) {
    reset && this.props.resetCustomer();
    this.setState({
      modal: false
    });
  }

  showLogoModal() {
    this.setState({
      logoModal: true
    });
  }

  closeLogoModal(reset) {
    reset && this.props.resetCustomer();
    this.setState({
      logoModal: false
    });
  }

  showConfirmDel(row) {
    const { customers } = this.props;
    let data = customers.data
      ? customers.data.find(x => x.id === parseInt(row, 10))
      : null;
    this.setState({
      currentRow: data,
      showConfirmDelete: true
    });
  }

  hideConfirmDel() {
    this.setState({
      currentRow: null,
      showConfirmDelete: false
    });
  }

  del() {
    this.props
      .del(this.state.currentRow.id, this.props.pager)
      .then(response => {
        this.setState({
          selected: {}
        });
      });
    this.hideConfirmDel();
  }

  selectedRows = rows => {
    this.setState({
      selected: rows
    });
  };

  removedSelectedRadioCheck = () => {
    this.setState({
      selected: {}
    });
  };

  render() {
    const {
      translate,
      languages,
      create,
      customerId,
      customer,
      customers,
      pager,
      update,
      fetch,
      removeLogo,
      search,
      resetCustomer,
      customerTargets4,
      customerTargets6,
      updateCustTargets4,
      updateCustTargets6,
      cableList,
      getCableList,
      updateCableList,
      DeleteCable,
      wireMap,
      getWireMap,
      countryStates,
      impersonating,
      softwareUpdate,
      smartFlagProfiles
    } = this.props;

    const { selected, selectAll, filterable } = this.state;

    let margintop = "150px";

    if (impersonating) {
      margintop = "215px";
    }

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }

    const _selected = { ...selected };
    let selectedRecords = Object.keys(selected).filter(x => selected[x]);

    let $modal = this.state.modal ? (
      <NewCustorg
        container="customers"
        languages={languages}
        mode={this.state.mode}
        modal={this.state.modal}
        close={this.closeModal}
        create={create}
        update={update}
        addLogo={this.showLogoModal}
        removeLogo={removeLogo}
        pager={pager}
        translate={translate}
        customer={customer}
        removedSelectedRadioCheck={this.removedSelectedRadioCheck}
        reset={resetCustomer}
        customerTargets4={customerTargets4}
        customerTargets6={customerTargets6}
        updateCustTargets4={updateCustTargets4}
        updateCustTargets6={updateCustTargets6}
        getCableList={getCableList}
        wireMap={wireMap}
        getWireMap={getWireMap}
        cableList={cableList}
        updateCableList={updateCableList}
        DeleteCable={ DeleteCable }
        countryStates={ countryStates}
        smartFlagProfiles={smartFlagProfiles}
        activeFeatures={this.props.activeFeatures}
      />
    ) : null;

    let $logoModal = this.state.logoModal ? (
      <CustorgLogo
        container="customers"
        languages={languages}
        modal={this.state.logoModal}
        mode={this.state.mode}
        customerId={customerId}
        customer={customer}
        cancel={this.closeLogoModal}
        pager={pager}
        translate={translate}
        logoStored={this.closeLogoModal}
      />
    ) : null;

    let $context = (
      <Context
        toggleColumns={this.toggleColumns}
        data={customers.data}
        columns={this.state.columns}
        translate={translate}
      />
    );

    let confirmText = translate("customer_delete_confirm_text", {
      name: this.state.currentRow ? this.state.currentRow.name : ""
    });

    return (
      <div style={{marginTop: margintop}}>
        <Title
          title={translate("general_customers")}
          toolbar={
            <Toolbar
              translate={translate}
              toggle={() => this.toggle()}
              add={() => this.add()}
              edit={() => this.edit(selectedRecords[0])}
              remove={() => this.showConfirmDel(selectedRecords[0])}
              selectedRecords={selectedRecords}
              toggleFilters={this.toggleFilters}
            />
          }
        />
        <Content
          ctx={$context}
          open={this.state.contextMenu}
          toggle={() => this.toggle()}
          translate={translate}
        >
          {filterable ? (
            <SearchBar search={search} pager={pager} translate={translate} />
          ) : null}
          <Table
            translate={translate}
            filterable={filterable}
            pages={customers.pagecount}
            manual={pager.manual}
            defaultPageSize={pager.pagesize}
            data={customers.data}
            columns={this.state.columns}
            fetch={fetch}
            allowSelectOne
            selectedRows={this.selectedRows}
            selected={_selected}
            minRows={0}
            pager={pager}
            style={{
              border: "none"
            }}
            noDataText="no_customer_data"
          />
          {$modal}
          {$logoModal}
          <ConfirmDialog
            open={this.state.showConfirmDelete}
            title={translate("customer_delete_title")}
            contentText={confirmText}
            contentSecondaryText={translate("general_confirmation_help_2")}
            okText={translate("general_confirm")}
            cancelText={translate("general_cancel")}
            onOk={this.del}
            onCancel={this.hideConfirmDel}
          />
        </Content>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  ...state,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(Customers);
